import { render, staticRenderFns } from "./GlobalTap.vue?vue&type=template&id=2f3c52dc&"
import script from "./GlobalTap.vue?vue&type=script&lang=js&"
export * from "./GlobalTap.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTap.vue?vue&type=style&index=0&id=2f3c52dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports